import React from "react";
import Panel from "../folio/Panel";
import CertificateStack from "../folio/CertificateStack";
import SkillIconField from "../folio/SkillIconField";
import { certificates, techStack, toolStack } from "../../data";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";

function SkillContainer() {
  const {cursor} = useCursor()
  return (
    <section 
    {...cursor({...CURSORS.hero,text:'',size:30,backgorund:"#fff"})}
    className="w-full bg-white px-4 py-6 sm:px-6 sm:py-8 md:h-screen md:max-h-screen md:px-8">
      <div className="mx-auto flex w-full flex-col gap-2 md:h-full md:flex-row">

        {/* Certificates */}
        <div className="h-[430px] w-full sm:h-[500px] md:h-full md:w-1/2">
          <Panel title="Certificates">
            <CertificateStack certificates={certificates} />
          </Panel>
        </div>

        {/* Skills */}
        <div className="flex w-full flex-col gap-2 md:h-full md:w-1/2">

          <div className="h-[300px] w-full sm:h-[350px] md:h-full md:min-h-0 md:flex-1">
            <Panel title="Tech Stack">
              <SkillIconField items={techStack} />
            </Panel>
          </div>

          <div className="h-[300px] w-full sm:h-[350px] md:h-full md:min-h-0 md:flex-1">
            <Panel title="Tool Stack">
              <SkillIconField items={toolStack} />
            </Panel>
          </div>

        </div>
      </div>
    </section>
  );
}

export default SkillContainer;